(()=>{'use strict';function initialize(){document.querySelectorAll('[data-age-explorer]').forEach(root=>{if(root.dataset.initialized)return;root.dataset.initialized='true';const buttons=[...root.querySelectorAll('[data-age-button]')],panels=[...root.querySelectorAll('[data-age-panel]')];function show(index){buttons.forEach((b,i)=>{const active=i===index;b.classList.toggle('is-active',active);b.setAttribute('aria-expanded',String(active));panels[i].hidden=!active;});}buttons.forEach((b,i)=>b.addEventListener('click',()=>show(b.getAttribute('aria-expanded')==='true'?-1:i)));root.querySelectorAll('[data-age-close]').forEach(b=>b.addEventListener('click',()=>show(-1)));});document.querySelectorAll('[data-toggle-search]').forEach(b=>{if(b.dataset.initialized)return;b.dataset.initialized='true';b.addEventListener('click',()=>{let panel=document.querySelector('[data-search-panel]');panel.hidden=!panel.hidden;if(!panel.hidden)panel.querySelector('input').focus();});});document.querySelectorAll('[data-mobile-toggle]').forEach(b=>{if(b.dataset.initialized)return;b.dataset.initialized='true';b.addEventListener('click',()=>{const menu=document.querySelector('[data-mobile-nav]');menu.hidden=!menu.hidden;b.setAttribute('aria-expanded',String(!menu.hidden));});});document.querySelectorAll('.product-detail__info').forEach(box=>{if(box.dataset.initialized)return;box.dataset.initialized='true';const selects=[...box.querySelectorAll('[data-product-option]')],variant=box.querySelector('[data-variant-select]');if(!selects.length||!variant)return;selects.forEach(s=>s.addEventListener('change',()=>{const values=selects.map(x=>x.value);const target=[...variant.options].find(opt=>opt.dataset.options.split('||').every((x,i)=>x===values[i]));if(target&&!target.disabled)variant.value=target.value;}));});}document.addEventListener('DOMContentLoaded',initialize);document.addEventListener('shopify:section:load',initialize);})();

/* Accessible product gallery and variants: independently initialized per product section. */
(()=>{
  function setup(root){
    if(root.dataset.productReady==='true')return;
    root.dataset.productReady='true';
    const hero=root.querySelector('.product-detail__hero-image');
    const thumbs=[...root.querySelectorAll('[data-product-thumb]')];
    const choices=[...root.querySelectorAll('[data-product-option]')];
    const variant=root.querySelector('[data-variant-select]');
    const price=root.querySelector('[data-product-price]');
    const status=root.querySelector('[data-variant-status]');
    const submit=root.querySelector('[data-add-to-cart]');
    function showImage(button){
      if(!button||!hero)return;
      hero.src=button.dataset.src;
      hero.srcset=button.dataset.srcset||'';
      hero.alt=button.dataset.alt||'';
      thumbs.forEach(t=>{
        const selected=t===button;
        t.classList.toggle('is-active',selected);
        t.setAttribute('aria-pressed',String(selected));
      });
    }
    thumbs.forEach(button=>button.addEventListener('click',()=>showImage(button)));
    function update(){
      if(!variant)return;
      const values=choices.map(c=>c.value);
      const match=[...variant.options].find(opt=>{
        const parts=(opt.dataset.options||'').split('||');
        return parts.length===values.length&&parts.every((v,i)=>v===values[i]);
      });
      if(!match){
        variant.value='';
        if(submit){submit.disabled=true;submit.textContent='Unavailable';}
        if(status)status.textContent='This option combination is unavailable.';
        return;
      }
      variant.value=match.value;
      const available=match.dataset.available==='true';
      if(submit){submit.disabled=!available;submit.textContent=available?'Add to Cart':'Sold Out';}
      if(price)price.textContent=match.dataset.price||price.textContent;
      if(status)status.textContent=available?'':'This variant is sold out.';
      if(match.dataset.imageId){
        const thumb=thumbs.find(t=>t.dataset.imageId===match.dataset.imageId);
        if(thumb)showImage(thumb);
      }
      try{
        const url=new URL(window.location.href);
        url.searchParams.set('variant',match.value);
        window.history.replaceState({...window.history.state},'',url.toString());
      }catch(e){}
    }
    choices.forEach(choice=>choice.addEventListener('change',update));
    if(variant)variant.addEventListener('change',()=>{
      const selected=variant.selectedOptions[0];
      if(selected){
        const parts=(selected.dataset.options||'').split('||');
        choices.forEach((choice,i)=>{if(parts[i]!==undefined)choice.value=parts[i];});
      }
      update();
    });
    update();
  }
  const init=()=>document.querySelectorAll('[data-product-detail]').forEach(setup);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
